function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  fill: "#009EE2",
  x: 0,
  y: 0,
  width: 36,
  height: 36
}), /*#__PURE__*/React.createElement("path", {
  d: "M30.712,20.812 C30.712,25.3435568 28.2944433,29.530888 24.3700001,31.7966664 C20.4455568,34.0624448 15.6104432,34.0624448 11.6859999,31.7966664 C7.76155666,29.530888 5.344,25.3435568 5.344,20.812 L5.344,2.412 L10.8,2.412 L10.8,20.812 C10.8000001,24.7729862 14.0110138,27.9839998 17.972,27.9839998 C21.9329862,27.9839998 25.1439999,24.7729862 25.144,20.812 C25.088,20.812 25.144,2.412 25.144,2.412 L30.712,2.412 L30.712,20.812 Z",
  fill: "#FFFFFF"
}));

var SvgStadtbahn = function SvgStadtbahn(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "36px",
    viewBox: "0 0 36 36",
    style: {
      background: "#009EE2"
    },
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStadtbahn, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/stadtbahn.9074cd9a.svg";
export { ForwardRef as ReactComponent };